export function formatNumber(number) {
  const value = Number(number || 0);
  if (value < 1000) return String(value);
  if (value < 1000000) return `${(value / 1000).toFixed(1)}K`;
  return `${(value / 1000000).toFixed(1)}M`;
}

export function formatMoney(value, decimals = 2) {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return '0.00';
  return number.toFixed(decimals);
}

export function formatTokenAmount(value, decimals = 2) {
  const number = Number(value || 0);
  if (!Number.isFinite(number)) return '0';
  const fixed = number.toFixed(decimals);
  return fixed.replace(/\.?0+$/, '');
}

export function shortAddress(address) {
  if (!address || address.length <= 12) return address || '';
  return `${address.slice(0, 6)}...${address.slice(-4)}`;
}

export function normalizeImageList(imageList) {
  if (Array.isArray(imageList)) return imageList.filter(Boolean);
  if (typeof imageList === 'string' && imageList.trim()) {
    try {
      const parsed = JSON.parse(imageList);
      if (Array.isArray(parsed)) return parsed.filter(Boolean);
    } catch (error) {
      return imageList.split(',').map((item) => item.trim()).filter(Boolean);
    }
  }
  return [];
}

export function formatRelativeTime(timestamp, t) {
  const value = Number(timestamp || 0);
  if (!value) return '';

  const diff = Date.now() - value;
  const minute = 60 * 1000;
  const hour = 60 * minute;
  const day = 24 * hour;

  if (diff < minute) return t('article.now');
  if (diff < hour) return `${Math.max(1, Math.floor(diff / minute))} ${t('article.minutesAgo')}`;
  if (diff < day) return `${Math.floor(diff / hour)} ${t('article.hoursAgo')}`;
  return `${Math.floor(diff / day)} ${t('article.daysAgo')}`;
}

export function formatTimelineTime(timestamp) {
  const value = Number(timestamp || 0);
  if (!value) return '';

  const date = new Date(value);
  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();

  const pad = (input) => String(input).padStart(2, '0');
  const time = `${pad(date.getHours())}:${pad(date.getMinutes())}`;
  return sameDay ? time : `${pad(date.getMonth() + 1)}-${pad(date.getDate())} ${time}`;
}
